import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@fetmode/i18n';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider.js';
export function ProtectedRoute({ children }) {
    const { user, isLoading } = useAuth();
    const location = useLocation();
    if (isLoading) {
        return _jsx("p", { children: t('common.auth.loading') });
    }
    if (!user) {
        return _jsx(Navigate, { to: "/login", replace: true, state: { from: location.pathname } });
    }
    return children;
}
//# sourceMappingURL=ProtectedRoute.js.map